export default {
	GLOBAL: {
		OPEN_FORM_SWITCHER: (callback) => {
			return {
				combo: "ctrl+shift+f",
				description: "Open form switcher",
				callback: callback
			};
		},
		DASHBOARD: (callback) => {
			return {
				combo: "alt+shift+1",
				description: "Dashboard",
				callback: callback
			};
		},
		NEW_REPORT: (label, callback) => {
			return {
				combo: "alt+shift+n",
				description: label,
				callback: callback
			};
		},
		REPORT_LIST: (label, callback) => {
			return {
				combo: "alt+shift+f",
				description: label,
				callback: callback
			};
		},
		REPORT_COMPLIANCE: (callback) => {
			return {
				combo: "alt+shift+r",
				description: "Reporting Status",
				callback: callback
			};
		},
		SHOW_NAVIGATION_BAR: (callback) => {
			return {
				combo: "alt+shift+q",
				description: "Open/Close side navigation bar",
				callback: callback
			};
		},
		QUICK_OPEN: (callback) => {
			return {
				combo: "alt+shift+g",
				description: "Quick Open report",
				callback: callback
			};
		}
	},
	REPORT_LIST: {
		VIEW_SELECTED_REPORTS: (description, callback) => {
			return {
				combo: "alt+shift+v",
				description: description,
				callback: callback
			};
		}
	},
	EDIT_REPORT: {
		ADD_DETAIL: (callback) => {
			return {
				combo: "alt+shift+s",
				description: "Add new detail row",
				callback: callback
			};
		},
		SAVE_HEADER: (callback) => {
			return {
				combo: "alt+shift+h",
				description: "Save header",
				callback: callback
			};
		},
		SUBMIT_TICKET: (label, callback) => {
			return {
				combo: "alt+shift+t",
				description: label,
				callback: callback
			};
		},
		DETAILS: {
			LOCK_FIELD: (callback) => {
				return {
					allowIn: ["INPUT", "SELECT", "TEXTAREA"],
					combo: "alt+l",
					description: "Toggle lock feature on focused field.",
					callback: callback
				};
			},
			SAVE_DETAIL: (callback) => {
				return {
					combo: "alt+s",
					allowIn: ["INPUT", "SELECT", "TEXTAREA"],
					description: "Save detail and close",
					callback: callback
				};
			},
			SAVE_AND_ADD_DETAIL: (callback) => {
				return {
					combo: "ctrl+shift+s",
					allowIn: ["INPUT", "SELECT", "TEXTAREA"],
					description: "Save detail and create new",
					callback: callback
				};
			}
		}
	}
};
